import { Token } from 'constant';
import { GlobalStats } from 'gql-ops/graph/__generated__/request';

import { makeAutoObservable } from 'mobx';
import storage from 'utils/storage';

interface ConfimModal {
    isOpen: boolean;
    attemptingTxn: boolean;
    hash: string;
    pendingText: string;
    errorMessage?: string;
    addTokenToMetamask?: Token;
    summery?: string;
}

export const InitConfirmModalConfig = {
    isOpen: false,
    attemptingTxn: false,
    hash: '',
    pendingText: '',
    errorMessage: undefined,
    addTokenToMetamask: undefined,
};

const skipGasNotification = storage.get('goat_onepiece_skip_gas_notification');

export class Application {
    openConnectWallet: boolean = false;
    confirmModal: ConfimModal = InitConfirmModalConfig;
    hideMainnet: boolean = true;
    // comingSoon: boolean = true;
    comingSoon: boolean = false;
    nftCount: number = 0;
    gec: number = 0;
    globalStats: GlobalStats | null = null;

    // skip gas notification
    skipGasNotification: boolean = skipGasNotification || false;

    constructor() {
        makeAutoObservable<this>(this);
    }

    toggleConnectWalletModal = () => {
        this.openConnectWallet = !this.openConnectWallet;
    };

    setConfimModal = (data: ConfimModal) => {
        this.confirmModal = data;
    };
    setCloseConfirModalState = () => {
        this.confirmModal = InitConfirmModalConfig;
    };
    setNftCount = (count: number) => {
        this.nftCount = count;
    };
    setGec = (gec: number) => {
        this.gec = gec;
    };

    setGlobalStats = (stats: GlobalStats) => {
        this.globalStats = stats;
    };

    setSkipGasNotification(skipGasNotification: boolean) {
        this.skipGasNotification = skipGasNotification;
        storage.set('goat_onepiece_skip_gas_notification', this.skipGasNotification);
    }
}

export default new Application();
